import { requests } from './baseServices'

export const ActivityServices = {    
    getAll: (criteria) => requests.get('api/activities', criteria),
    getAllWithOptions: (criteria) => requests.post('api/activities/filtered', criteria),
    getById: (id) => requests.get(`api/activities/${id}`),
    update: (id, activity) => requests.put(`api/activities/${id}`, activity),
    create: (user) => requests.post(`api/activities`, user),
    delete: (id) => requests.delete(`api/activities/${id}`),
    duplicate: (id) => requests.post(`api/activities/duplicate/${id}`),
    getUserActivities: () => requests.get(`api/activities/user`),
    saveHours: (activityHours) => requests.put(`api/activities/updateHours`, activityHours),
    search: (query) => requests.get(`api/activities/search/`, query)

};